import { ISO_CODE_NETHERLANDS } from '@constants/countries';

/**
 * @description Returns if the current website is dutch
 * @example <caption>Example usage of isNetherlands</caption>
 * isNetherlands()
 * @return {*}  {boolean}
 */
const isNetherlands = (): boolean =>
    window.__ENVIRONMENT_DETAILS__.languageIsoCode === ISO_CODE_NETHERLANDS;

export { isNetherlands };
